import { Component } from 'preact'
import Switcher from '../../control/Switcher'

class Permissions extends Component {
  constructor (props) {
    super()
    this.permissionToggles = ['visibility', 'create_topics', 'create_posts']
  }

  updatePermission (idx, key) {
    let permissions = [].concat(this.props.permissions)
    permissions[idx][key] = !this.props.permissions[idx][key]
    this.props.onUpdate(permissions)
  }

  render (props) {
    if (!props.permissions.length) {
      return
    }

    return (
      <div className='permissions'>
        {
          props.permissions.map((eachRole, idx) => (
            <div>
              {
                idx === props.mainCount ? <hr /> : null
              }
              {
                idx === 0 || idx === props.mainCount ? (
                  <div className='permissions_row permissions_title'>
                    <div className='permissions_column'>{idx === 0 ? 'Default roles' : 'Customised roles' }</div>
                    <div className='permissions_column'>Category visibility</div>
                    <div className={`permissions_column ${(props.isKnowledgeBase || props.isNews) ? 'invisible' : ''}`}>Create topics</div>
                    <div className='permissions_column'>Create comments</div>
                  </div>
                ) : null
              }
              <div className='permissions_row'>
                <div className='permissions_column'>{eachRole.title}</div>
                {
                  this.permissionToggles.map((type) => (
                    <div className={`permissions_column ${(props.isKnowledgeBase || props.isNews) && type === 'create_topics' ? 'invisible' : ''}`}>
                      <Switcher
                        disable={type !== 'visibility' && props.disableCreatePermissionsList.indexOf(eachRole.role) !== -1}
                        on={props.permissions[idx][type]}
                        onChange={() => this.updatePermission(idx, type)} />
                    </div>
                  ))
                }
              </div>
            </div>
          ))
        }
      </div>
    )
  }
}

export default Permissions
